import React from 'react';
import cn from 'classnames';
import FilterIcon from 'assets/icons/filter';

interface FilterButtonProps {
  isActive: boolean;
  onClick: () => void;
  icon?: React.ReactNode;
  className?: string;
}

const FilterButton: React.FC<FilterButtonProps> = ({
  isActive,
  onClick,
  icon,
  className = '',
}) => (
  <button
    type="button"
    className={cn(
      'p-2 rounded-xl shadow-md border',
      isActive ? 'bg-[#1d67b6]' : 'bg-white',
      className
    )}
    onClick={onClick}
    aria-pressed={isActive}
  >
    {icon || <FilterIcon color={isActive ? '#fff' : '#010D1D'} />}
  </button>
);

export default FilterButton;
